import { FormConfig } from 'src/app/shared/models/dynamic.model';
import { AdvanceSearchTriStateValue } from '../advanced-search-specialsearches/advanced-search-specialsearches.constants';

export const advancedSearchManifestFormFieldsConfig: FormConfig = {
  fields: [
    {
      id: 'origin',
      type: 'input',
      label: 'Origin',
    },
    {
      id: 'destination',
      type: 'input',
      label: 'Destination',
    },
    {
      label: 'Agent',
      id: 'receivingAgent',
      type: 'input',
    },
    {
      id: 'manifestId',
      type: 'input',
      label: 'Manifest ID',
    },
    {
      id: 'manifestNumber',
      type: 'input',
      label: 'Manifest Number',
    },
  ],
};

/**
 * Manifests-tab fields no longer rendered on any host. PAC-24594 removed them from
 * the Shipments and Bags hosts (D-ASF-001); they are now removed from MAWB as well.
 * The keys stay in `ManifestsModal` so legacy pinned searches still restore cleanly,
 * and every host strips them from the submit payload. (PAC-24790)
 */
export const removedManifestFieldIds: string[] = [
  'FinalDestination',
  'clearanceType',
  'customer',
];

export interface ManifestsModal {
  origin: string;
  destination: string;
  receivingAgent: string;
  FinalDestination: string;
  clearanceType: string;
  customer: string;
  manifestId: string;
  manifestNumber: string;
  /** Tri-state publish filter (PAC-24649 AC3); Shipment/Bag/MAWB hosts only. */
  published: AdvanceSearchTriStateValue;
}

export const defaultManifestsModal: ManifestsModal = {
  origin: '',
  destination: '',
  receivingAgent: '',
  FinalDestination: '',
  clearanceType: '',
  customer: '',
  manifestId: '',
  manifestNumber: '',
  published: '',
};

export interface ManifestModalStateModel {
  manifestModal: ManifestsModal;
}

// Initial state
export const defaultManifestState: ManifestModalStateModel = {
  manifestModal: defaultManifestsModal,
};
